import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const FaqServiceSupport = React.lazy(() => import('.'));

export const faqServiceSupportRoutes = [
  new Route({
    path: 'faq-service-support',
    element: FaqServiceSupport,
    children: [],
  }),
];
